<template>
  <!-- RegionsChart starts here -->
  <div class="row">
    <div class="zonal-wrapper">
      <div class="">
        <div
          class="col-md-12"
          style="
            height: 30px;
            background-color: #dff3f3;
            display: flex;
            align-items: center;
          "
        >
          <div class="text-center title_placement col-xs-6 zonal-head">
            <h4 style="margin: 0">
              <label style="position: relative; font-size: 13px">
                <!-- Zonal Charts -->
                Geopolitical Zonal Chart
                <span class="hidden">{{ indicatorSelected }}</span>
              </label>
            </h4>
          </div>
          <div class="col-sm-6">
            <div class="col-sm-12" style="display: flex">
              <div class="zonal-multisel">
                <div class="">
                  <multi-select
                    v-model="selectedSource"
                    :options="optionSources"
                    :hide-selected="false"
                    :searchable="true"
                    :allow-empty="false"
                    :show-labels="false"
                    @click="click++"
                    placeholder=""
                  >
                  </multi-select>
                </div>
                <div class="">
                  <multi-select
                    v-model="selectedYear"
                    :options="optionYear"
                    :hide-selected="false"
                    :searchable="true"
                    :allow-empty="false"
                    :show-labels="false"
                    @click="click++"
                    placeholder=""
                  >
                  </multi-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="chart-stage col-sm-12 col-md-12">
      <div class="col-sm-6 col-md-8 region-chart">
        <v-icon
          class="expand-icon-highBarChart"
          v-tooltip.top="'Expand chart'"
          @click="highBarChart = true"
          >zoom_out_map</v-icon
        >
        <highcharts :options="optionsObj"></highcharts>
        <b-modal :active.sync="highBarChart" has-modal-card>
          <div class="highBarChart-modal-card">
            <header class="modal-card-head" style="text-align: center">
              <p class="modal-card-title">{{ indicatorName }}</p>
            </header>
            <highcharts :options="optionsObj"></highcharts>
            <footer class="modal-card-foot">
              <button
                class="button is-danger pull-right"
                type="button"
                @click="highBarChart = false"
              >
                CLOSE
              </button>
            </footer>
          </div>
        </b-modal>
      </div>
      <div class="col-sm-6 col-md-4">
        <div class="col-sm-12">
          <!-- <div class="hidden"><label for="">{{computeMapData}}</label></div> -->
          <div v-show="nodata" class="chart-has-no-data" style="border: 0">
            <img src="static/img/no_data.svg" style />
            <!-- <b-notification type="is-custom" :active.sync="chartHasNoData">
                    <strong>Info! &nbsp;</strong> No data available
              </b-notification>-->
          </div>
          <div class="chart-wrapper" v-if="!nodata" style="border: 0">
            <div
              v-show="!dataAvailable && !regionsDataAvailable"
              class="chart-has-no-data"
            >
              <img src="static/img/no_data.svg" style="" />
              <!-- <b-notification type="is-custom" :active.sync="chartHasNoData">
                    <strong>Info! &nbsp;</strong> No data available
                  </b-notification> -->
            </div>
            <div v-show="dataAvailable" v-if="stat" class="chart-stage">
              <v-icon
                v-tooltip.top="'Expand chart'"
                @click="expandChart = true"
                class="expand-icon-highmap"
                >zoom_out_map</v-icon
              >
              <highmaps
                style="z-index: 0"
                :options="mapOptions"
                ref="highmaps"
              ></highmaps>
            </div>
            <div class="chart-stage" v-else>
              <div class="ml-4 text-right">
                <button @click="stat = true" class="btn btn-sm">
                  Back to National
                </button>
              </div>
              <v-icon
                v-tooltip.top="'Expand chart'"
                @click="expandChart = true"
                class="expand-icon-highmap"
                >zoom_out_map</v-icon
              >
              <highmaps
                style="z-index: 0"
                :options="lgaOptions"
                ref="highmaps"
              ></highmaps>
            </div>
            <div
              v-show="!dataAvailable && regionsDataAvailable"
              class="chart-stage"
            >
              <v-icon
                v-tooltip.top="'Expand chart'"
                @click="expandChart = true"
                class="expand-icon-highmap"
                >zoom_out_map</v-icon
              >
              <highmaps
                style="z-index: 0"
                :options="mapOptions1"
                ref="highmaps"
              ></highmaps>
            </div>
          </div>
          <b-modal :active.sync="expandChart" has-modal-card>
            <form action="">
              <div class="modal-card" style="width: 90vw">
                <header class="modal-card-head" style="text-align: center">
                  <p class="modal-card-title">{{ indicatorName }}</p>
                </header>
                <section>
                  <highmaps
                    v-show="dataAvailable"
                    v-if="stat"
                    style="z-index: 0"
                    :options="mapOptions"
                    ref="highmaps"
                  ></highmaps>
                  <highmaps
                    v-else
                    style="z-index: 0"
                    :options="lgaOptions"
                    ref="highmaps"
                  ></highmaps>
                  <highmaps
                    v-show="!dataAvailable && regionsDataAvailable"
                    style="z-index: 0"
                    :options="mapOptions1"
                    ref="highmaps"
                  ></highmaps>
                </section>
                <footer class="modal-card-foot">
                  <button
                    class="button is-danger pull-right"
                    type="button"
                    @click="expandChart = false"
                  >
                    CLOSE
                  </button>
                </footer>
              </div>
            </form>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import MultiSelect from 'vue-multiselect'
// import vueSlider from 'vue-slider-component';
import { Carousel3d, Slide } from "vue-carousel-3d";
import sortObjects from "@/assets/js-on/sortObjects";
import map_data from "@/assets/js-on/nigmap_regions_state_data";
import regions_map_data from "@/assets/js-on/nigmap_region_data";
import {
  jigawa,
  kano,
  katsina,
  kebbi,
  sokoto,
  kaduna,
  zamfara,
} from "@/assets/js-on/north-west";
import {
  nasarawa,
  niger,
  plateau,
  kwara,
  kogi,
  benue,
  fct,
} from "@/assets/js-on/north-central";
import { abia, ebonyi, imo, enugu, anambra } from "@/assets/js-on/south-east";
import { ondo, ogun, osun, lagos, ekiti, oyo } from "@/assets/js-on/south-west";
import {
  akwaIbom,
  bayelsa,
  crossRiver,
  rivers,
  delta,
  edo,
} from "@/assets/js-on/south-south";
import {
  adamawa,
  bauchi,
  borno,
  gombe,
  taraba,
  yobe,
} from "@/assets/js-on/north-east";

export default {
  name: "regionsChart",
  components: {
    Carousel3d,
    Slide,
    MultiSelect: () => import("vue-multiselect"),
  },
  // props: ['chartData', 'appData', 'selectedIndicator','dashboardStateOptions','metaData'],
  props: [
    "chartData",
    "lgaData",
    "appData",
    "meta_data",
    "selectedIndicator56",
    "dashboardStateOptions",
    "sources",
  ],
  data() {
    return {
      // fullscreen: true,
      nodata: false,
      click: 1,
      stateClicked: "",
      stat: true,
      selectedYear: "",
      optionYear: [],
      lga: [],
      regionColors: [
        {
          region: [
            "North-West",
            "Kebbi",
            "Zamfara",
            "Kano",
            "Sokoto",
            "Kaduna",
            "Jigawa",
            "Katsina",
          ],
          color: "#EB928F",
        },
        {
          region: [
            "North-East",
            "Taraba",
            "Adamawa",
            "Gombe",
            "Bauchi",
            "Yobe",
            "Borno",
          ],
          color: "#8AB9BB",
        },
        {
          color: "#89D880", //'#58B74E',
          region: [
            "North-Central",
            "Plateau",
            "Benue",
            "Nasarawa",
            "Niger",
            "Kwara",
            "FCT",
            "Kogi",
          ],
        },
        {
          color: "#FFFF00", //'#BB7A17',
          region: [
            "South-South",
            "Bayelsa",
            "Cross River",
            "Akwa Ibom",
            "Delta",
            "Edo",
            "Rivers",
          ],
        },
        {
          color: "#7D8ADE", //'#58A5E8',
          region: [
            "South-West",
            "Osun",
            "Ekiti",
            "Ondo",
            "Oyo",
            "Ogun",
            "Lagos",
          ],
        },
        {
          color: "#F872A0", //'#CF3C64',
          region: ["South-East", "Ebonyi", "Enugu", "Anambra", "Abia", "Imo"],
        },
      ],
      states: {
        Adamawa: adamawa,
        Delta: delta,
        "Akwa Ibom": akwaIbom,
        Ekiti: ekiti,
        Enugu: enugu,
        Osun: osun,
        Rivers: rivers,
        Kwara: kwara,
        Anambra: anambra,
        Edo: edo,
        " Bayelsa": bayelsa,
        Niger: niger,
        Plateau: plateau,
        Nasarawa: nasarawa,
        Gombe: gombe,
        Borno: borno,
        Benue: benue,
        "Cross River": crossRiver,
        Bauchi: bauchi,
        Kogi: kogi,
        Lagos: lagos,
        Taraba: taraba,
        Yobe: yobe,
        Jigawa: jigawa,
        Kano: kano,
        FCT: fct,
        Katsina: katsina,
        Kebbi: kebbi,
        Sokoto: sokoto,
        Zamfara: zamfara,
        Abia: abia,
        Bayelsa: bayelsa,
        Ebonyi: ebonyi,
        Imo: imo,
        Ondo: ondo,
        Ogun: ogun,
        Oyo: oyo,
        Kaduna: kaduna,
      },
      optionStates: [
        "National",
        "Abia",
        "Adamawa",
        "Akwa Ibom",
        "Anambra",
        "Bauchi",
        "Benue",
        "Borno",
        "Bayelsa",
        "Cross River",
        "Delta",
        "Ebonyi",
        "Edo",
        "Ekiti",
        "Enugu",
        "FCT",
        "Gombe",
        "Imo",
        "Jigawa",
        "Kaduna",
        "Kebbi",
        "Kano",
        "Katsina",
        "Kogi",
        "Kwara",
        "Lagos",
        "Nasarawa",
        "Niger",
        "Ogun",
        "Ondo",
        "Osun",
        "Oyo",
        "Plateau",
        "Rivers",
        "Sokoto",
        "Taraba",
        "Yobe",
        "Zamfara",
      ],
      dataSources: [
        "MICS",
        "NDHS",
        "NARHS",
        "NMIS",
        "NNHS",
        "NHMIS",
        "World Bank",
        "IHME",
        "WHO-GHO",
        "WUENIC",
        "PCCS",
        "UNAIDS",
        "NHSPSS",
        "NHA",
        "KDGHS",
        "NAIIS",
      ],
      optionsYear: [], //[2017, 2016, 2015, 2014, 2013],
      lsData: JSON.parse(this.$ls.get("car_other_dataset")),
      metaData: JSON.parse(this.$ls.get("meta_data_dataset")),
      nationalTarget: "",
      sdgTarget: "",
      selectedIndicator: "",

      optionsObj: {
        chart: {
          type: "column",
          zoomType: "xy",
          height: 400,
        },
        title: {
          text: "Loading...",
          style: {
            fontSize: "16px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "600",
          },
        },
        subtitle: {
          text: "Loading...",
          style: {
            fontSize: "11px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "normal",
          },
        },
        xAxis: {
          type: "category",
          labels: {
            rotation: -45,
            style: {
              fontSize: "11px",
              fontFamily: '"Open Sans", sans-serif',
              fontWeight: "normal",
            },
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          align: "center",
          // verticalAlign: 'middle',
          // layout: 'vertical'
          itemStyle: {
            fontSize: "11px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "600",
          },
        },
        yAxis: {
          min: 0,

          title: {
            text: "Values",
          },
          gridLineWidth: 0,
          labels: {
            style: {
              fontSize: "9px",
              fontFamily: '"Open Sans", sans-serif',
              fontWeight: "600",
            },
          },
        },
        plotOptions: {
          series: {
            pointWidth: 8,
          },
        },

        tooltip: {
          headerFormat: "<b>Region/State Value<b><br>",
          pointFormat: "<b>{point.name}:</b> {point.y:.2f}",
        },
        series: [],
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 700,
                },
                xAxis: {
                  type: "category",

                  labels: {
                    rotation: 0,
                    style: {
                      fontSize: "8px",
                      fontFamily: '"Open Sans", sans-serif',
                      fontWeight: "600",
                    },
                  },
                },
              },
            },
          ],
        },
      },
      tempData: "",
      selectedSource: "",
      optionSources: [],

      highBarChart: false,
      expandChart: false,
      dataAvailable: false,
      regionsDataAvailable: false,
      indicatorName: "",
      lgaOptions: {
        chart: {
          borderColor: "#335cad",
          height: 438,
        },

        credits: {
          enabled: false,
          text: "",
        },

        title: {
          text: "",
          style: {
            fontSize: "16px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "600",
          },
        },

        subtitle: {
          text: "",
          style: {
            fontSize: "11px",
            fontFamily: '"Open Sans", sans-serif',
          },
        },

        exporting: {
          csv: {
            dateFormat: "%Y-%m-%d",
          },
        },

        mapNavigation: {
          // enableDoubleClickZoomTo: true,
          enabled: true,
          buttonOptions: {
            verticalAlign: "middle",
            align: "right",
          },
        },

        legend: {
          enabled: true,
          itemStyle: {
            fontSize: "10px",
          },
        },

        plotOptions: {
          map: {
            events: {},
            color: "#BADC55",
            allAreas: true,
            // Highcharts.maps['countries/ng/ng-all'],
            states: {
              hover: {
                color: "#BADA55",
              },
            },

            dataLabels: {
              allowOverlap: true,
              enabled: true,
              //format: '{point.name}',
              color: "#FFFFFF",
              formatter: function () {
                if (this.point.value) {
                  return this.point.name;
                }
              },
            },
            tooltip: {
              headerFormat: "<b>{series.name}</b><br>",
              pointFormat: "{point.name}: <b>{point.value}</b>",
            },
          },
        },
        series: [],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                "printChart",
                "separator",
                "downloadPNG",
                "downloadJPEG",
                "downloadPDF",
                "downloadSVG",
                "separator",
                "downloadCSV",
                "downloadXLS",
                //"viewData",
                "openInCloud",
              ],
              symbol: "download",
            },
          },
        },
      },
      mapOptions: {
        chart: {
          borderColor: "#335cad",
          height: 438,
        },

        credits: {
          enabled: false,
          text: "Map of Nigeria",
        },

        title: {
          text: "Loading...",
          style: {
            fontSize: "16px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "600",
          },
        },

        subtitle: {
          text: "Loading...",
          style: {
            fontSize: "11px",
            fontFamily: '"Open Sans", sans-serif',
          },
        },

        mapNavigation: {
          // enableDoubleClickZoomTo: true,
          enabled: true,
          buttonOptions: {
            verticalAlign: "middle",
            align: "right",
          },
        },

        legend: {
          enabled: true,
          itemStyle: {
            fontSize: "10px",
          },
        },

        plotOptions: {
          map: {
            events: {
              click: (e) => {
                this.stateClicked = e.point.name;
                this.prepareLgaMap(this.stateClicked);
                this.stat = false;
              },
            },
            allAreas: false,
            mapData: map_data, // Highcharts.maps['countries/ng/ng-all'],
            states: {
              hover: {
                color: "#BADA55",
              },
            },

            dataLabels: {
              allowOverlap: true,
              enabled: true,
              //format: '{point.name}',
              color: "#FFFFFF",
              formatter: function () {
                if (this.point.value) {
                  return this.point.name;
                }
              },
            },
            tooltip: {
              headerFormat: "<b>{series.name}</b><br>",
              pointFormat: "{point.name}: <b>{point.value}</b>",
            },
          },
        },
        series: [],
      },
      mapOptions1: {
        chart: {
          map: "countries/ng/ng-all",
          borderColor: "#335cad",
          height: 438,
        },

        credits: {
          enabled: false,
          text: "Map of Nigeria",
        },

        title: {
          text: "Loading...",
        },

        subtitle: {
          text: "Loading...",
        },

        mapNavigation: {
          // enableDoubleClickZoomTo: true,
          enabled: true,
          buttonOptions: {
            verticalAlign: "middle",
            align: "right",
          },
        },

        legend: {
          enabled: false,
          layout: "vertical",
          align: "right",
        },

        plotOptions: {
          map: {
            allAreas: false,
            mapData: regions_map_data, // regions map path
            states: {
              hover: {
                color: "#BADA55",
              },
            },
            joinBy: "hc-key",
            dataLabels: {
              enabled: true,
              //format: '{point.name}',
              color: "#FFFFFF",
              formatter: function () {
                if (this.point.value) {
                  return this.point.name;
                }
              },
            },
            tooltip: {
              // headerFormat: '<b>{series.name}</b><br>',
              headerFormat: "<b>{point.name}</b><br>",
              pointFormat: "{point.name}: <b>{point.value}</b>",
            },
          },
        },
        series: [],
      },
    };
  },
  methods: {
    getYearOptionsWithAvailableData(arg) {
      var string = "string";
      if (typeof arg == string) {
        let theYears = [];
        let statesByIndicatorByYear =
          this.$store.getters.getCurrentIndicatorsValue;
        let indicatorSource = this.selectedIndicator + " -> " + arg;

        let indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource) - 1;
        for (var i in statesByIndicatorByYear) {
          statesByIndicatorByYear[i].map((el, i) => {
            if (el[indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
              if (theYears.indexOf(el[0]) < 0) {
                theYears.push(el[0]);
              }
            }
          });
        }
        this.optionYear = theYears.sort(function (a, b) {
          return b - a;
        });
      } else {
        let years = [];
        let rightOptions = [];
        for (var one in this.optionSources) {
          rightOptions[one] = {
            name: this.optionSources[one],
            yrs: [],
          };
        }
        for (var item in rightOptions) {
          let theYears = [];
          let statesByIndicatorByYear =
            this.$store.getters.getCurrentIndicatorsValue;
          let indicatorSource =
            this.selectedIndicator + " -> " + rightOptions[item].name;
          let indicatorSourceIndex =
            this.lsData[0].indexOf(indicatorSource) - 1;
          for (var i in statesByIndicatorByYear) {
            statesByIndicatorByYear[i].map((el, i) => {
              if (el[indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
                if (theYears.indexOf(el[0]) < 0) {
                  theYears.push(el[0]);
                }
              }
            });
          }
          rightOptions[item].yrs.push(
            theYears.sort(function (a, b) {
              return b - a;
            })
          );
        }
        var latestYrs = [];
        for (var opt in rightOptions) {
          latestYrs.push(rightOptions[opt].yrs[0][0]);
        }
        for (var val in rightOptions) {
          if (rightOptions[val].yrs[0][0] == Math.max(...latestYrs)) {
            this.selectedSource = rightOptions[val].name;
            break;
          }
        }

        // latestYrs.push(rightOptions[three].yrs[0])
      }

      //
    },
    getCurrentSourceOptions() {
      let sources = [];
      var statesByIndicatorByYear =
        this.$store.getters.getCurrentIndicatorsValue;
      for (var k in this.dataSources) {
        for (var i in statesByIndicatorByYear) {
          for (var j in statesByIndicatorByYear[i]) {
            // console.log(this.selectedIndicator);

            let indicatorSource =
              this.selectedIndicator + " -> " + this.dataSources[k];
            let indicatorSourceIndex =
              this.lsData[0].indexOf(indicatorSource) - 1;
            // console.log(indicatorSourceIndex);
            if (
              statesByIndicatorByYear[i][j][indicatorSourceIndex] !== "" &&
              indicatorSourceIndex > 0
            ) {
              if (sources.indexOf(this.dataSources[k]) < 0)
                sources.push(this.dataSources[k]);
              break;
            }
          }
        }
      }
      ////World bank, and the sources that come after never have sub-national data
      // if(sources.indexOf("World Bank")!==-1){
      //   sources.splice(sources.indexOf("World Bank"))
      // }
      this.optionSources = sources;
    },
    getDisplayFactor() {
      let displayFactor = "";
      for (const i in this.metaData) {
        if (this.metaData[i][0] === this.selectedIndicator) {
          displayFactor = this.metaData[i][3];

          break;
        }
      }
      this.optionsObj.yAxis.title.text = displayFactor;
      // console.log(this.optionsObj.yAxis.title.text);
      // console.log(displayFactor);
    },
    getMapPlotData() {
      var stateByIndicatorByYear =
        this.$store.getters.getCurrentIndicatorsValue;

      var selectedIndicatorValuesForEachState = {};

      var indicatorSource =
        this.selectedIndicator + " -> " + this.selectedSource;
      var indexOfindicatorSource = this.lsData[0].indexOf(indicatorSource) - 1;
      // get the current year with values for each indicator...
      var statesWithIndicatorsYearAndValues =
        this.getYearWithCurrentIndicatorValues(
          indexOfindicatorSource,
          stateByIndicatorByYear
        );
      // what is the idea behind this?
      if (statesWithIndicatorsYearAndValues[1] !== -Infinity) {
        for (var stateName in stateByIndicatorByYear) {
          if (stateByIndicatorByYear.hasOwnProperty(stateName)) {
            // var len = stateByIndicatorByYear[o].length;
            var stateCurrentYearVals =
              stateByIndicatorByYear[stateName][
                statesWithIndicatorsYearAndValues[2][stateName]
              ];
            selectedIndicatorValuesForEachState[stateName] = [
              stateCurrentYearVals[0],
              stateCurrentYearVals[indexOfindicatorSource],
            ]; // stateByIndicatorByYear[stateName][len - 1]
          }
        }
      } else {
        selectedIndicatorValuesForEachState =
          statesWithIndicatorsYearAndValues[0];
      }

      var temp = Object.keys(selectedIndicatorValuesForEachState);
      var obj = {};
      var statesValue;
      temp.map((elem, index) => {
        statesValue = selectedIndicatorValuesForEachState[elem][1];
        obj[elem] = statesValue; //? statesValue: ""; //selectedIndicatorValuesForEachState[elem][1];
      });
      var regions = [
        "North-East",
        "North-West",
        "North-Central",
        "South-East",
        "South-West",
        "South-South",
      ];

      var sortedObj = sortObjects(obj); // custom method

      var xAxis = [],
        yAxis = [],
        regionsYAxis = [],
        regionsXAxis = [];
      for (let stateName in sortedObj) {
        if (sortedObj.hasOwnProperty(stateName)) {
          if (regions.indexOf(stateName) < 0) {
            // don't need the regions in this chart
            yAxis.push(stateName);
            xAxis.push(sortedObj[stateName] ? sortedObj[stateName] : 0);
          } else {
            regionsYAxis.push(stateName);
            regionsXAxis.push(sortedObj[stateName] ? sortedObj[stateName] : 0);
          }
        }
      }
      let plotData = [];
      let tempPlotData = {};
      // get the data required for ngMap
      yAxis.map((elem, index) => {
        tempPlotData[elem] = xAxis[index] ? xAxis[index] : 0;
      });
      plotData.push(tempPlotData);

      tempPlotData = {};

      regionsYAxis.map((elem, index) => {
        tempPlotData[elem] = regionsXAxis[index] ? regionsXAxis[index] : 0;
      });
      plotData.push(tempPlotData);

      return plotData;
    },
    plotZonalChart() {
      this.getCurrentSourceOptions();
      this.getYearOptionsWithAvailableData(this.selectedSource);
      if (!this.selectedYear)
        this.selectedYear = Math.max.apply(null, this.optionYear);
      // // Regional Data to populate the Chart

      //MAde colour changes here
      var regions = [
        { name: "National", color: "#474747", data: [["National"]] },
        {
          name: "North-West",
          color: "#7e4e22", //'rgb(126,78,34)',//'#EB928F',//'#E85D58',
          data: [
            ["North-West"],
            ["Kebbi"],
            ["Zamfara"],
            ["Kano"],
            ["Sokoto"],
            ["Kaduna"],
            ["Jigawa"],
            ["Katsina"],
          ],
        },
        {
          name: "North-East",
          color: "#8AB9BB", //'rgb(138,185,187)',//'#17606B',
          data: [
            ["North-East"],
            ["Taraba"],
            ["Adamawa"],
            ["Gombe"],
            ["Bauchi"],
            ["Yobe"],
            ["Borno"],
          ],
        },
        {
          name: "North-Central",
          color: "#89D880", //'rgb(137,216,128)',//'#58B74E',
          data: [
            ["North-Central"],
            ["Plateau"],
            ["Benue"],
            ["Nasarawa"],
            ["Niger"],
            ["Kwara"],
            ["FCT"],
            ["Kogi"],
          ],
        },
        {
          name: "South-South",
          color: "#e1e164", //'rgb(125,138,222)',//'#BB7A17',
          data: [
            ["South-South"],
            ["Bayelsa"],
            ["Cross River"],
            ["Akwa Ibom"],
            ["Delta"],
            ["Edo"],
            ["Rivers"],
          ],
        },
        {
          name: "South-West",
          color: "#7D8ADE", //'rgb(248,114,160)',//'#7D8ADE',//'#58A5E8',
          data: [
            ["South-West"],
            ["Osun"],
            ["Ekiti"],
            ["Ondo"],
            ["Oyo"],
            ["Ogun"],
            ["Lagos"],
          ],
        },
        {
          name: "South-East",
          color: "#F872A0", //'rgb(225,225,100)',//'#CF3C64',
          data: [
            ["South-East"],
            ["Ebonyi"],
            ["Enugu"],
            ["Anambra"],
            ["Abia"],
            ["Imo"],
          ],
        },
      ];

      var selectedYear;
      this.optionsObj.exporting = {
        buttons: {
          contextButton: {
            menuItems: [
              "printChart",
              "separator",
              "downloadPNG",
              "downloadJPEG",
              "downloadPDF",
              "downloadSVG",
              "separator",
              "downloadCSV",
              "downloadXLS",
              //"viewData",
              "openInCloud",
            ],

            symbol: "download",
          },
        },
        filename:
          this.selectedIndicator +
          " (" +
          this.selectedSource +
          " - " +
          this.selectedYear +
          ")",
      };
      this.optionsObj.series = [];
      var multipleDataSource = this.$store.state.CAR.lsDataMultipleSources;
      selectedYear = this.selectedYear;
      var yearData = [];
      var columnHeader = multipleDataSource[0];
      var indicatorIndex = columnHeader.indexOf(
        this.selectedIndicator + " -> " + this.selectedSource
      );

      for (var i = 0; i < multipleDataSource.length; i++) {
        if (multipleDataSource[i][0] == selectedYear) {
          // console.log(multipleDataSource);
          yearData.push(multipleDataSource[i]);
        }
      }

      var stateData;

      for (var i = 0; i < yearData.length; i++) {
        for (var x = 0; x < regions.length; x++) {
          //Iterates through all the data in regions
          for (var y = 0; y < regions[x].data.length; y++) {
            if (yearData[i][1] == regions[x].data[y][0]) {
              // console.log(yearData[i][1]);

              stateData = yearData[i][indicatorIndex];
              stateData = stateData == "" ? 0 : stateData;
              // console.log(stateData);

              regions[x].data[y].push(parseFloat(stateData));
            } else {
              // console.log(yearData[i][1] +' - '+regions[x].data[y][0]);
            }
          }
        }
      }

      //Sort the initial array of object regions to sort based on regions with higher values
      let tempRegions = regions.slice(1);

      tempRegions.sort((a, b) => {
        return b.data[0][1] - a.data[0][1];
      });
      // console.log(tempRegions);

      //Sort data array excluding the regions
      tempRegions.map((elem, index) => {
        let sliceElem = elem.data.slice(1);

        sliceElem.sort((a, b) => {
          return b[1] - a[1];
        });
        sliceElem.unshift(elem.data[0]);
        elem.data = sliceElem;
      });

      tempRegions.unshift(regions[0]);
      regions = tempRegions;

      let currRegLength = 0;

      for (let i = 0; i < regions.length; i++) {
        currRegLength = currRegLength + regions[i].data.length;

        //Default for National data
        if (i == 0) {
          for (let x = 0; x < 43; x++) {
            regions[0].data.push([null, null]);
          }
        }
        //Logic for other regions
        else {
          let regLength = currRegLength - regions[i].data.length;
          let regionsLeft = 44 - currRegLength;

          for (let x = 0; x < regLength; x++) {
            // console.log(regions[i]);
            regions[i].data.unshift([null, null]);
          }
          for (let y = 0; y < regionsLeft; y++) {
            regions[i].data.push([null, null]);
          }
        }
      }

      this.optionsObj.series = regions;

      this.optionsObj.title.text = this.selectedIndicator;
      this.optionsObj.subtitle.text =
        "Source: " + this.selectedSource + " " + this.selectedYear;

      var ivt =
        this.$store.state.CAR.indicatorAttributesOtherSources[
          this.selectedIndicator
        ];

      var vt = ivt[1] === "P" ? "%" : "";
      var it = ivt[1] === "P" ? "% of total" : "";
      // console.log(ivt);

      // console.log(it);
      let nationalTarget;
      let sdgTarget;
      if (this.meta_data !== null) {
        this.meta_data.map((elem) => {
          if (this.selectedIndicator == elem[0]) {
            nationalTarget = elem[7];
            sdgTarget = elem[10];

            this.nationalTarget = nationalTarget;
            this.sdgTarget = sdgTarget;
          }

          // console.log(elem[7]);
        });
      }

      this.optionsObj.yAxis.plotLines = [];
      let nationalTargetLine = {
        id: "nationalLineID",
        color: "#222222",
        width: 0.5,
        value: this.nationalTarget,
        label: {
          text: "NT: " + this.nationalTarget + vt, // vt is value type; whether percentage or number
          align: "right",
          rotation: 90,
          y: -9,
          x: 1,
          style: {
            fontSize: "12px",
            fontFamily: '"Open Sans", sans-serif',
          },
        },
      };

      let sdgTargetLine = {
        id: "sdgLineID",
        color: "#222222",
        width: 0.5,
        value: this.sdgTarget,
        dashStyle: "longdashdot",
        label: {
          text: "SDG: " + this.sdgTarget, // vt is value type; whether percentage or number
          align: "right",
          rotation: 0,
          y: 12,
          x: 0,
        },
      };

      // console.log(nationalTargetLine);
      if (this.nationalTarget) {
        this.optionsObj.yAxis.plotLines.push(nationalTargetLine);
        // console.log(this.optionsObj.yAxis.plotLines);
      }

      if (this.sdgTarget) {
        // console.log(this.sdgTarget);
        this.optionsObj.yAxis.plotLines.push(sdgTargetLine);
      }
      // console.log(this.sdgTargetLine)
    },
    getYearWithCurrentIndicatorValues(
      indexOfindicatorSource,
      stateByIndicatorByYear
    ) {
      var statesWithIndicatorsYearAndValues = {};
      var tempArr = {}; // this is an object with statename as key and the rowIndex where for the selectedYear as value
      var sourceActiveYear = {};
      var sourcetempArr = [];

      for (var stateName in stateByIndicatorByYear) {
        if (stateByIndicatorByYear.hasOwnProperty(stateName)) {
          for (
            var i = stateByIndicatorByYear[stateName].length - 1;
            i >= 0;
            i--
          ) {
            statesWithIndicatorsYearAndValues[stateName] = [];
            var selectedIndicatorVal =
              stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
            if (
              stateByIndicatorByYear[stateName][i][0] ===
              parseInt(this.selectedYear)
            ) {
              tempArr[stateName] = i;
              statesWithIndicatorsYearAndValues[stateName].push(
                stateByIndicatorByYear[stateName][i][0],
                stateByIndicatorByYear[stateName][i][indexOfindicatorSource]
              );
              break;
            }
          }
          // get all the years where there's a value for the indicator...
          for (
            var i = stateByIndicatorByYear[stateName].length - 1;
            i >= 0;
            i--
          ) {
            if (!sourceActiveYear[stateName]) {
              sourceActiveYear[stateName] = {};
            }
            var selectedIndicatorVal =
              stateByIndicatorByYear[stateName][i][indexOfindicatorSource];

            if (selectedIndicatorVal) {
              sourcetempArr.push(i);
              sourceActiveYear[stateName][
                stateByIndicatorByYear[stateName][i][0]
              ] = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
            }
          }
        }
      }
      var rowIndex = Math.max.apply(null, tempArr);
      // console.log(rowIndex);
      return [statesWithIndicatorsYearAndValues, rowIndex, tempArr];
    },

    /**
     * Map methods starts here
     */

    // for creating a color shade for states in same region based on their values.
    /* former implementation of shadeColor, was changed cus color was returning another range */
    // shadeColor(color, percent) {
    //   // convert color codes to integers with radix 16
    //   var R = parseInt(color.substring(1, 3), 16);
    //   var G = parseInt(color.substring(3, 5), 16);
    //   var B = parseInt(color.substring(5, 7), 16);

    //   // scale to 255
    //   R = parseInt(R * ((100 + percent) / 100));
    //   G = parseInt(G * ((100 + percent) / 100));
    //   B = parseInt(B * ((100 + percent) / 100));

    //   // readjust scale
    //   R = R > 0 ? (R < 255 ? R : R - 255) : R + 255;
    //   G = G > 0 ? (G < 255 ? G : G - 255) : G + 255; // (G>0)?G: R+255;
    //   B = B > 0 ? (B < 255 ? B : B - 255) : B + 255;

    //   var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
    //   var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
    //   var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));
    //   if(percent!==0){
    //      return "#" + RR + GG + BB;
    //   } else{
    //     RR = 255;
    //     GG = 255;
    //     BB = 23;
    //     return "#" + RR + GG + BB;
    //   }

    // },
    // for creating a color shade for states in same region based on their values.

    shadeColor(col, percent) {
      var usePound = false;
      if (col[0] == "#") {
        col = col.slice(1);
        usePound = true;
      }

      var num = parseInt(col, 16);

      var r = (num >> 16) + percent;

      if (r > 255) r = 255;
      else if (r < 0) r = 0;

      var b = ((num >> 8) & 0x00ff) + percent;

      if (b > 255) b = 255;
      else if (b < 0) b = 0;

      var g = (num & 0x0000ff) + percent;

      if (g > 255) g = 255;
      else if (g < 0) g = 0;

      if (percent !== 0) {
        return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
        return "#" + RR + GG + BB;
      }
    },
    plotMap() {
      let allMapPlotData = this.getMapPlotData();
      let mapPlotData = allMapPlotData[0];

      this.mapOptions.title.text = this.selectedIndicator;
      this.indicatorName = this.selectedIndicator;
      this.mapOptions.subtitle.text =
        this.selectedSource + "-" + this.selectedYear;
      this.mapOptions.exporting = {
        buttons: {
          contextButton: {
            menuItems: [
              "printChart",
              "separator",
              "downloadPNG",
              "downloadJPEG",
              "downloadPDF",
              "downloadSVG",
              "separator",
              "downloadCSV",
              "downloadXLS",
              //"viewData",
              "openInCloud",
            ],
            symbol: "download",
          },
        },
        csv: {
          dateFormat: "%Y-%m-%d",
        },
        filename:
          this.selectedIndicator +
          " (" +
          this.selectedSource +
          " - " +
          this.selectedYear +
          ")",
      };
      this.mapOptions.series = [];
      // this.mapOptions1.series = [];
      // if (!mapPlotData) {
      //   return;
      // }
      // var map = map_data;
      var tempMaxValue = [];
      var regionStatesMapProp = map_data;
      let state = Object.values(mapPlotData);
      let count = 0;
      for (var i in state) {
        if (state[i] === 0) {
          count++;
        }
      }
      if (count === 37) {
        this.nodata = true;
      } else {
        this.nodata = false;
      }
      for (var value in mapPlotData) {
        if (mapPlotData.hasOwnProperty(value)) {
          tempMaxValue.push(mapPlotData[value]);
        }
      }

      // var maxValue = Math.max.apply(null, tempMaxValue);
      var color = [
        "#8AB9BB",
        "#7e4e22",
        "#89D880",
        "#7D8ADE",
        "#F872A0",
        "#e1e164",
      ];
      // iterate over the 6 regions

      regionStatesMapProp.map((regionArray, index) => {
        regionArray.color = color[index];
        regionArray.data.map((stateInRegion, index2) => {
          stateInRegion.value = mapPlotData[stateInRegion.name];

          // this block compares the national target and the values to be plotted so that the extremes of the y-axis can capture all data.

          // if (maxValue <= this.nationalTarget){
          //   this.optionsObj.yAxis.max = this.nationalTarget+10;
          // }
          // else{
          //   this.optionsObj.yAxis.max = maxValue+10;
          // }

          // if (maxValue > 100) {
          //   var percentageValue = (stateInRegion.value / (Math.ceil(maxValue) + 100)) * 100;
          //   stateInRegion.color = this.shadeColor(color[index], -percentageValue)

          // }
          // else {
          //   stateInRegion.color = this.shadeColor(color[index], -(stateInRegion.value))
          // }
          // console.log(maxValue);
        });

        this.mapOptions.series.push(regionArray);

        //Check if the states has data
        for (var i in regionArray.data) {
          if (regionArray.data[i].value > 0) {
            this.dataAvailable = true;
            break;
          } else {
            this.dataAvailable = false;
          }
        }
      });
    },
    splitLGADistrict() {
      /// Seperating the lgas and senetorial districts
      var lgaDistrict = this.lgaData;
      if (lgaDistrict !== null) {
        lgaDistrict.map((elem) => {
          var theLGADist = elem[2].split(" ");
          theLGADist = theLGADist[theLGADist.length - 1];
          // console.log(theLGADist);
          if (theLGADist === "LGA") {
            this.lga.push(elem);
            // console.log(elem);
          }
          if (theLGADist === "Dist.") {
            //this.district.push(elem)
          }
        });
      }
      // console.log(this.lga);
    },
    prepareLgaMap(state) {
      this.splitLGADistrict();
      let theMapData;
      state = this.stateClicked;
      this.lgaOptions.series.pop();
      this.lgaOptions.series.push(this.states[state]);
      // console.log(this.lgaData);
      theMapData = this.states[state].data;
      this.plotLgaMap(theMapData);
    },
    plotLgaMap(lgaMap) {
      /// Assigns colors to the states based on region
      for (var one in this.regionColors) {
        if (this.regionColors[one].region.indexOf(this.stateClicked) != -1) {
          this.lgaOptions.plotOptions.map.color = this.regionColors[one].color;
        }
      }

      let indicatorFind = this.selectedIndicator + " -> " + this.selectedSource;
      //console.log(this.lga)
      let theIndex = this.lgaData[0].indexOf(indicatorFind);
      let filteredData = this.lga.filter(
        (val, index) =>
          val[0] == this.selectedYear && val[1] == this.stateClicked
      );

      //This function  handles the value assignments to each LGA
      lgaMap.map((val, index) => {
        filteredData.map((i, ind) => {
          if (i[2].startsWith(val.name)) {
            val.value = i[theIndex];
          }
        });
      });
      //  console.log(lgaMap);
      this.lgaOptions.title.text = this.selectedIndicator;
      this.indicatorName = this.selectedIndicator;
      this.lgaOptions.subtitle.text =
        this.selectedSource + "-" + this.selectedYear;
    },
    plotRegionsMap() {
      let allMapPlotData = this.getMapPlotData();
      let mapPlotData = allMapPlotData[1];

      this.mapOptions1.title.text = this.selectedIndicator;
      this.indicatorName = this.selectedIndicator;
      this.mapOptions1.subtitle.text =
        this.selectedSource + "-" + this.selectedYear;
      this.mapOptions1.exporting = {
        buttons: {
          contextButton: {
            menuItems: [
              "printChart",
              "separator",
              "downloadPNG",
              "downloadJPEG",
              "downloadPDF",
              "downloadSVG",
              "separator",
              "downloadCSV",
              "downloadXLS",
              //"viewData",
              "openInCloud",
            ],
            symbol: "download",
          },
        },
        csv: {
          dateFormat: "%Y-%m-%d",
        },
        filename:
          this.selectedIndicator +
          " (" +
          this.selectedSource +
          " - " +
          this.selectedYear +
          ")",
      };
      this.mapOptions1.series = [];

      var tempMaxValue = [];
      var regionStatesMapProp = regions_map_data;

      for (var value in mapPlotData) {
        if (mapPlotData.hasOwnProperty(value)) {
          tempMaxValue.push(mapPlotData[value]);
        }
      }
      var maxValue = Math.max.apply(null, tempMaxValue);
      var color = [
        "#83CFDB",
        "#EB928F",
        "#7D8ADE",
        "#89D880",
        "#FFFF17",
        "#BAC7FC",
      ];

      // iterate over the 6 regions
      regionStatesMapProp.map((regionArray, index) => {
        regionArray.color = color[index];

        let regionsToShortCode = {
          "North-East": "ng-ne",
          "North-West": "ng-nw",
          "North-Central": "ng-nc",
          "South-East": "ng-se",
          "South-West": "ng-sw",
          "South-South": "ng-ss",
        };

        regionArray.data = Object.keys(regionsToShortCode).map(
          (elem, index) => {
            return [regionsToShortCode[elem], mapPlotData[elem]];
          }
        );

        this.mapOptions1.series.push(regionArray);
        //console.log(mapPlotData);
        // Check if the regions have data, i.e non-zero values
        let regionValues = Object.values(mapPlotData);
        let count = 0;
        for (var i in regionValues) {
          if (regionValues[i] === 0) {
            count++;
          }
        }
        if (count === 6) {
          this.regionsDataAvailable = false;
          this.nodata = true;
        } else {
          this.regionsDataAvailable = true;
          this.nodata = false;
        }
      });
    },
  },
  computed: {
    indicatorSelected() {
      this.selectedIndicator = this.$store.getters.getSelectedIndicator;
    },
  },
  created() {
    // get the program area indicator grouping
    this.dataSources = this.sources;
  },
  mounted() {
    //  this.selectedIndicator = this.selectedIndicator56;
    if (this.lsData) {
      this.splitLGADistrict();
      this.optionsYear = this.yearOptions;
      if (this.dashboardStateOptions.length > 0) {
        this.selectedYear = this.dashboardStateOptions[5];
      } else {
        this.getCurrentSourceOptions();
        this.getYearOptionsWithAvailableData(this.optionSources);
        this.selectedYear = Math.max.apply(null, this.optionYear);
      }
      this.isDataLoadedFirstTime = true;
      this.getCurrentSourceOptions();
      this.getYearOptionsWithAvailableData(this.optionSources);
      this.selectedYear = Math.max.apply(null, this.optionYear);
      // this.plotZonalChart();
      this.$emit("callerName", "regionsChartYear");
      this.$emit("regionsChartYear", this.selectedYear);
      // this.getMapPlotData();
      if (this.metaData) {
        this.getDisplayFactor();
      }
    }
  },
  updated() {},
  watch: {
    selectedYear(val) {
      this.stat = true;
      if (this.lsData) {
        this.plotZonalChart();
        this.$emit("callerName", "regionsChartYear");
        this.$emit("regionsChartYear", val);
        this.plotMap();
        this.plotRegionsMap();
      }
    },
    selectedIndicator(val) {
      this.stat = true;
      if (this.lsData) {
        if (this.dashboardStateOptions.length > 0) {
          this.selectedYear = this.dashboardStateOptions[5];
        } else {
          this.getCurrentSourceOptions();
          this.getYearOptionsWithAvailableData(this.optionSources);
          this.selectedYear = Math.max.apply(null, this.optionYear);
        }

        setTimeout(() => {
          this.plotZonalChart();
        }, 5);
        this.plotMap();
        this.plotRegionsMap();
      }
      if (this.metaData) {
        this.getDisplayFactor();
      }
    },
    selectedSource(val) {
      this.stat = true;
      if (this.lsData) {
        this.getYearOptionsWithAvailableData(val);
        this.selectedYear = Math.max.apply(null, this.optionYear);
        this.plotZonalChart();
        this.plotMap();
        this.plotRegionsMap();
      }
    },
    dashboardStateOptions(val) {
      if (this.lsData) {
        if (val.length > 0) {
          this.selectedYear = val[5];
        } else {
          this.getCurrentSourceOptions();
          this.getYearOptionsWithAvailableData(this.optionSources);
          this.selectedYear = Math.max.apply(null, this.optionYear);
        }
        this.plotZonalChart();
        this.plotMap();
        this.plotRegionsMap();
      }
    },
    appData(val) {
      if (val) {
        this.lsData = val;
        // this.optionsYear = this.yearOptions
        if (this.dashboardStateOptions.length > 0) {
          this.selectedYear = this.dashboardStateOptions[5];
        } else {
          this.getCurrentSourceOptions();
          this.getYearOptionsWithAvailableData(this.optionSources);
          this.selectedYear = Math.max.apply(null, this.optionYear);
        }
        this.isDataLoadedFirstTime = true;
        this.plotZonalChart();
        this.plotMap();
        this.plotRegionsMap();
        this.$emit("callerName", "regionsChartYear");
        this.$emit("regionsChartYear", this.selectedYear);
        if (this.metaData) {
          this.getDisplayFactor();
        }
      }
    },

    selectedYear(val) {
      this.stat = true;
      if (this.lsData) {
        this.plotZonalChart();
        this.$emit("callerName", "regionsChartYear");
        this.$emit("regionsChartYear", val);
        this.plotMap();
        this.plotRegionsMap();
      }
    },
  },
};
</script>

<style scoped>
div[class^="col"] {
  padding-left: 7px;
  padding-right: 7px;
}

.rowlTop {
  margin-bottom: -30px !important;
}

.rowlBot {
  margin-top: -30px !important;
}

/* Some styles live in App.vue file*/
</style>



// WEBPACK FOOTER //
// regionsChart.vue?d47d7b92